/* ====================== PARTIE DATA  ==================== */
/* == Définition des datas par défaut pour chaque charge == */
/* ======================================================== */

import MotorDesign from '@/domain/enums/MotorDesign'
import Feedable from '@/global/dejaVue/feedable'
import { ChargeModelVisitorInterface } from './ChargeModelVisitorInterface'
import { ChargeViewModel } from './chargePatronModel'
import MotorCodeModel from './motorCode'
import TypeCharge from './typeCharge'

export interface VisitableChargeModel {
  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel
}

export class Harmonics extends Feedable {
  id = 0
  n3 = 0
  n5 = 0
  n7 = 0
  n9 = 0
  n11 = 0
  n13 = 0
  n15 = 0
  n17 = 0
  n19 = 0

  constructor(options?: any) {
    super()
    this.feed(options)
  }
}

export class HarmonicsHelper {
  static getFromArray(ichdArray: number[] | undefined): Harmonics {
    const harmonics = new Harmonics()
    if (ichdArray != undefined && ichdArray.length > 0) {
      let i = 0
      Object.keys(harmonics).forEach(key => {
        if (key != 'id') {
          if (i < ichdArray.length) {
            ; (harmonics as any)[key] = ichdArray[i]
          }
          i++
        }
      })
    }
    return harmonics
  }

  static getFromICHD(ichd: string | undefined) {
    const harmonics = new Harmonics()
    if (ichd != undefined) {
      const ichdArray = JSON.parse(ichd)
      if (ichdArray.length > 0) {
        let i = 0
        Object.keys(harmonics).forEach(key => {
          if (key != 'id') {
            if (i < ichdArray.length) {
              ; (harmonics as any)[key] = ichdArray[i]
            }
            i++
          }
        })
      }
    }
    return harmonics
  }

  static areHarmonicsEquals(h1: Harmonics, h2: Harmonics) {
    return (
      h1.n3 == h2.n3 &&
      h1.n5 == h2.n5 &&
      h1.n7 == h2.n7 &&
      h1.n9 == h2.n9 &&
      h1.n11 == h2.n11 &&
      h1.n13 == h2.n13 &&
      h1.n15 == h2.n15 &&
      h1.n17 == h2.n17 &&
      h1.n19 == h2.n19
    )
  }

  static prepareForCompute(harmonics: Harmonics) {
    return [
      harmonics?.n3,
      harmonics?.n5,
      harmonics?.n7,
      harmonics?.n9,
      harmonics?.n11,
      harmonics?.n13,
      harmonics?.n15,
      harmonics?.n17,
      harmonics?.n19
    ]
  }
}
export class ChargeModel extends Feedable implements VisitableChargeModel {
  [x: string]: any
  id = 0
  description = ''
  type = 0
  nom = ''
  meta_Order = 1
  meta_StepOrder = 1
  step = 1
  //readyForcalculation = false
  loads = new Set<ChargeModel>()
  /* Les champs de données qui seraient en commun entre toutes les données des charges */

  constructor(options?: any) {
    super()
  }
  readyForcalculation(): boolean {
    return true
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    throw new Error('Method not implemented.')
  }
}
export interface LoadWhithEfficiency {
  efficiency: number
  manualEfficiency: boolean
}
export interface LoadWithHarmonics extends ChargeModel {
  harmonics?: Harmonics
  ithd?: number
  userIthd?: boolean
  haveInputFilter: boolean
}
export interface LoadWithLoadConnection extends ChargeModel {
  idLoadConnection?: number
}
export interface LoadWithStartingPower extends ChargeModel {
  startingPower?: number
  powerAmpsValue: number
}
export interface LoadWithLoadFactor extends ChargeModel {
  loadFactor: number
}
export class PowerFactorGeneric extends ChargeModel {
  runningPF?: number
  startingPF?: number
  manualRpf = true
  manualSpf = true
}

export class ChargeLighting extends ChargeModel
  implements LoadWithLoadConnection, LoadWithHarmonics, LoadWithLoadFactor {
  type = TypeCharge.Lighting
  nom = 'Lighting'
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  unit = 'kW'
  powerAmpsValue = 0
  haveInputFilter = false
  idLightingType = 1
  idBallast = 1
  runningPF = 1
  runningKW = 0
  startingPF = 1
  ithd?: number
  userIthd = false
  loadFactor = 1
  calculation = 0
  harmonics = new Harmonics()

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.Lighting
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitLighting(this)
  }
}
export class ChargeBatteryCharger extends ChargeModel
  implements LoadWithLoadConnection, LoadWithHarmonics {
  type = TypeCharge.BatteryCharger

  nom = 'BatteryCharger'
  description = ''
  qt = 1
  unit = 'kW' // future liste des unités de mesure
  powerAmpsValue = 0
  idLoadConnection = 9
  idVoltage = 13
  idBatteryType = 0
  idTypeRectifier = 0
  haveInputFilter = false
  currentCharge = 0
  runningPF = 1
  runningKW = 0
  startingPF = 1
  ithd?: number
  userIthd = false
  harmonics = new Harmonics()
  calculation = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.BatteryCharger
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitBatteryCharger(this)
  }
}
export class ChargeOfficeEquipement extends PowerFactorGeneric
  implements LoadWithLoadConnection, LoadWithHarmonics {
  type = TypeCharge.OfficeEquipement
  nom = 'OfficeEquipement'
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  numberOfComputer = 0
  numberOfPrinter = 0
  numberOfFax = 0
  numberOfCopiers = 0
  runningPF = 0.01
  runningKW = 0
  startingPF = 0.01
  ithd?: number
  userIthd = false
  harmonics = new Harmonics()
  calculation = 0
  haveInputFilter = false

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.OfficeEquipement
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitOfficeEquipment(this)
  }
}
export class ChargeMiscLinear extends PowerFactorGeneric
  implements LoadWithLoadConnection, LoadWithStartingPower, LoadWithLoadFactor {
  type = TypeCharge.LinearLoad
  nom = 'LinearLoad'
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  unit = 'kW'
  powerAmpsValue = 0.0
  isOff = false
  startingPower = 0.0
  runningPF = 1.0
  runningKW = 0
  startingPF = 1.0
  loadFactor = 1.0
  calculation = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.LinearLoad
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitMiscLinear(this)
  }
}
export class ChargeMiscNonLinear extends ChargeModel
  implements LoadWithLoadConnection, LoadWithHarmonics, LoadWithStartingPower, LoadWithLoadFactor {
  type = TypeCharge.NoLinearLoad
  nom = 'NoLinearLoad'
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  unit = 'kW'
  powerAmpsValue = 0
  haveInputFilter = false
  runningPF = 0.9
  runningKW = 0
  idUpsType = 1
  isOff = false
  startingPower = 0
  startingPF = 0.9
  ithd?: number
  loadFactor = 1
  userIthd = false
  harmonics = new Harmonics()
  calculation = ''

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.NoLinearLoad
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitNonMiscLinear(this)
  }
}

export class ChargeUPS extends PowerFactorGeneric
  implements LoadWithHarmonics, LoadWithLoadConnection, LoadWhithEfficiency {
  type = TypeCharge.UPS
  nom = 'UPS'
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  haveInputFilter = false
  idUpsType = 2
  outputRating = 0
  loadingPercentage = 100.0
  batteryChargerPercentage = 25.0
  runningPF = 0.85
  runningKW = 0
  startingPF = 0.85
  ithd = 28.9
  userIthd = false
  efficiency = 0.9
  manualEfficiency = true
  harmonics = new Harmonics()
  calculation = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.UPS
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitUPS(this)
  }
}
export class ChargeMedicalEquipement extends ChargeModel
  implements LoadWithLoadConnection {
  type = TypeCharge.MedicalEquipment
  nom = 'MedicalEquipment'
  description = ''
  qt = 1
  idLoadConnection = 2
  idVoltage = 13
  maxVoltageDip = 15
  maxPeakKVA = 0
  runningKW = 0
  pFAtMaxPeakKVA = 0.9
  continuousKVA = 0
  continuousPF = 0.9
  isOff = false
  calculation = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.MedicalEquipment
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitMedicalEquipment(this)
  }
}
export class ChargeWelder extends ChargeModel
  implements LoadWithLoadConnection, LoadWithHarmonics, LoadWithLoadFactor {
  type = TypeCharge.Welder
  nom = 'Welder'
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  haveInputFilter = false
  runningKVA = 0
  runningKW = 0
  peakKVA = 0
  idWelderSpec = 1
  isOff = false
  runningPF = 0.8
  startingPF = 0.4
  ithd = 12.0
  userIthd = false
  loadFactor = 1.0
  harmonics = new Harmonics()
  calculation = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.Welder
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitWelder(this)
  }
}

export class ChargeMotorGeneric extends PowerFactorGeneric
  implements LoadWithLoadConnection, LoadWithHarmonics, LoadWhithEfficiency, LoadWithLoadFactor {
  description = ''
  qt = 1
  idLoadConnection = 9
  idVoltage = 13
  powerAmpsValue = 0
  startingAmps = 0
  numberOfPhases = 3
  haveInputFilter = false
  idMotorCodeLetter = 1
  idMotorStartingMethod = 1
  idMotorVFDType? = 1
  idMotorSinglePhaseType: number | undefined = 1
  sCCL = 3
  design: MotorDesign = MotorDesign.NEMA
  isLoaded = true
  isOff = false
  runningPF = 0.01
  runningKW = 0
  startingPF = 0.01
  ithd?: number
  userIthd = false
  vFDSkVaLimit? = 100.0
  vFDEfficiency? = 0.9
  efficiency = 0.5
  harmonics = new Harmonics()
  calculation = 0
  loadFactor = 1.0
  manualMotorCodeLetter = true
  motoCode?: MotorCodeModel
  manualEfficiency = true
  unit = ''
  readyForcalculation(): boolean {
    return this.powerAmpsValue != 0
  }
}
export class ChargeMotor extends ChargeMotorGeneric {
  type = TypeCharge.Motor
  nom = 'Motor'
  unit = 'HP'

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.Motor
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitMotor(this)
  }
}
export class ChargeAirConditionner extends ChargeMotorGeneric {
  type = TypeCharge.AirConditioner
  nom = 'AirConditioner'
  unit = 'Tons'
  numberOfCompressors = 1
  tonHeating = 0
  sEER = 13

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.AirConditioner
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitAirConditionner(this)
  }
}
export class ChargeFirePump extends ChargeMotorGeneric {
  type = TypeCharge.FirePump
  nom = 'FirePump'
  description = ''
  unit = 'kVA'
  isVoltageDipLock = true

  isNECRequirement = true

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.FirePump
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitFirePump(this)
  }
}
export class ChargeElevator extends ChargeMotorGeneric {
  type = TypeCharge.Elevator
  nom = 'Elevator'
  unit = 'HP'
  haveRegenerativeDrive = false
  regenerativeDrivePercentage = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.Elevator
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitElevator(this)
  }
}
export class ChargeATS extends ChargeModel {
  type = TypeCharge.ATS
  nom = 'ATS'
  description = ''
  amps = 0

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.ATS
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitATS(this)
  }
}
export class ChargeTransformer extends ChargeModel {
  type = TypeCharge.Transformer
  nom = 'Transformer'
  description = ''
  kVARating = 0
  idPrimaryVoltage = 13
  idSecondaryVoltage = 13

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.Transformer
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitTransformer(this)
  }
}
export class ChargeCircuitBreaker extends ChargeModel {
  type = TypeCharge.CircuitBreaker
  nom = 'CircuitBreaker'
  description = ''
  amps = 0
  percentageRating = 80

  constructor(options?: any) {
    super(options)
    this.feed(options, true)
    this.type = TypeCharge.CircuitBreaker
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitCircuitBreaker(this)
  }
}
export class ChargeGenerator extends ChargeModel {
  type = TypeCharge.Generator
  nom = 'Generator'
  description = ''
  qt = 1
  phase = 3
  voltage = ''
  frequency = ''

  constructor(options?: any) {
    super(options)
    this.feed(options)
    this.type = TypeCharge.Generator
  }

  accept(visitor: ChargeModelVisitorInterface): ChargeViewModel {
    return visitor.visitGenerator(this)
  }
}

export class ChargeModelHelper {
  static getFromBack(loadFromBack: any): ChargeModel {
    const loadType = loadFromBack['loadType']
    let newLoad = new ChargeModel()
    switch (loadType) {
      case 'AirConditioner':
        newLoad = new ChargeAirConditionner(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'BatteryCharger':
        newLoad = new ChargeBatteryCharger(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'Elevator':
        newLoad = new ChargeElevator(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'FirePump':
        newLoad = new ChargeFirePump(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'Lighting':
        newLoad = new ChargeLighting(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'LinearLoad':
        newLoad = new ChargeMiscLinear(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'MedicalEquipment':
        newLoad = new ChargeMedicalEquipement(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'Motor':
        newLoad = new ChargeMotor(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'NoLinearLoad':
        newLoad = new ChargeMiscNonLinear(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'OfficeEquipment':
        newLoad = new ChargeOfficeEquipement(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'UPS':
        newLoad = new ChargeUPS(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'Welder':
        newLoad = new ChargeWelder(loadFromBack)
        newLoad.runningKW = loadFromBack['RunningKw']
        break
      case 'ATS':
        newLoad = new ChargeATS(loadFromBack)
        break
      case 'CircuitBreaker':
        newLoad = new ChargeCircuitBreaker(loadFromBack)
        break
      case 'Transformer':
        newLoad = new ChargeTransformer(loadFromBack)
        break
      default:
        break
    }

    const childLoads = loadFromBack['loads']
    if (childLoads != undefined && childLoads.length > 0) {
      childLoads.forEach((childLoadFromBack: any) => {
        const chargeModel = ChargeModelHelper.getFromBack(childLoadFromBack)
        newLoad.loads.add(chargeModel)
      })
    }

    return newLoad
  }
}
